import * as React from 'react';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';
import { trackOpenContacts, trackShowPhone } from './tracking';
import { Phone } from '../../components/Phone';
import { getGaLabel } from '../../selectors/newbuilding';
import { TShowPhoneAction } from '../../types/analytics/call';
import { CallButton } from '../CallButton';

export interface IModalCallButtonProps {
  callAction: TShowPhoneAction;
  placeType: string;
}

export const ModalCallButton = ({ callAction, placeType }: IModalCallButtonProps) => {
  const gaLabel = useSelector(getGaLabel);

  const onShowPhoneClick = React.useCallback(() => {
    trackShowPhone(gaLabel, callAction);
  }, [gaLabel, callAction]);

  const onOpenContactsClick = React.useCallback(() => {
    trackOpenContacts(gaLabel);
  }, [gaLabel]);

  return (
    <CallButton
      SinglePhoneComponent={Phone}
      placeType={placeType}
      onOpenContactsClick={onOpenContactsClick}
      onShowPhoneClick={onShowPhoneClick}
      openContactsStyles={{ size: 'M' as const, fullWidth: true }}
      showPhoneStyles={{
        size: 'M' as const,
        fullWidth: true,
        beforeIcon: <IconCommunicationPhone16 color="icon-inverted-default" />,
      }}
    />
  );
};

ModalCallButton.displayName = 'ModalCallButton';
